import { define, c } from '@components/Component.js'
import { h } from '@core/dom.js'

define('PromosCarousel', ({ items = [] }) => {
    const track = h('div', { className: 'promos-carousel__track' })
    items.forEach(item => track.appendChild(c('PromoCard', item)))

    let dragging = false, startX = 0, scrollLeft = 0
    track.addEventListener('mousedown', e => {
        dragging = true
        startX = e.clientX
        scrollLeft = track.scrollLeft
        track.style.scrollBehavior = 'auto'
        track.style.cursor = 'grabbing'
    })
    track.addEventListener('mousemove', e => {
        if (!dragging) return
        e.preventDefault()
        track.scrollLeft = scrollLeft - (e.clientX - startX)
    })
    const endDrag = () => {
        if (!dragging) return
        dragging = false
        track.style.cursor = ''
        track.style.scrollBehavior = ''
    }
    track.addEventListener('mouseup', endDrag)
    track.addEventListener('mouseleave', endDrag)

    const prev = h('button', { className: 'carousel-arrow carousel-arrow--prev', type: 'button' }, '‹')
    const next = h('button', { className: 'carousel-arrow carousel-arrow--next', type: 'button' }, '›')

    prev.addEventListener('click', () => {
        track.scrollBy({ left: -track.offsetWidth * 0.8, behavior: 'smooth' })
    })
    next.addEventListener('click', () => {
        track.scrollBy({ left: track.offsetWidth * 0.8, behavior: 'smooth' })
    })

    return h('div', { className: 'promos-carousel' }, prev, track, next)
})
